import Component from '@glimmer/component';
import { each } from 'lodash';
import { action, computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { set } from '@ember/object';
import { installDropdown } from 'mewe/utils/dropdown-utils';

/**
 * USAGE
 * <BasicUi::MwSort @options={{someOptions}}/>
 *
 * someOptions congi object with subOptions containing options values
 *
 * action on select is called in parentView
 * and subOption that was selected is passed to this action
 *  {
      subOptions: [
        {
          label: __('Newest'),
          action: 'oderByNewest',
          selected: true
        },
        {
          label: __('Oldest'),
          action: 'oderByOldest',
          selected: false
        } .. etc
      ]
    }
 *
 *
 */


export default class MwSort extends Component {
  @tracked dropdownOptions;

  constructor() {
    super(...arguments);

    installDropdown(this, 'dropdownOptions', { onUpdate: this.args.sortStateUpdate });
  }

  @computed('args.options.subOptions.@each.selected')
  get selectedOption() {
    return this.args.options?.subOptions?.find(o => o.selected);
  }

  @computed('args.options.subOptions.@each.selected')
  get isDefaultSelected() {
    const selected = this.selectedOption;
    return selected ? selected.default : true;
  }

  @action
  subOptionCheck(subOption) {
    each(this.args.options.subOptions, (option) => {
      set(option, 'selected', false);
    });

    set(subOption, 'selected', true);

    this.args[subOption.action](subOption);

    this.args.onClose?.();
  }
}